import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ExperienceTimeoutError } from './ExperienceTimeoutError';
function mergeAttributes(first, last) {
  if (first === undefined) {
    return last;
  }
  if (last === undefined) {
    return first;
  }
  return _objectSpread(_objectSpread({}, first), last);
}
export var Experience = /*#__PURE__*/function () {
  function Experience(_ref) {
    var name = _ref.name,
      id = _ref.id,
      timeout = _ref.timeout,
      _ref$startTime = _ref.startTime,
      startTime = _ref$startTime === void 0 ? window.performance.now() : _ref$startTime,
      attributes = _ref.attributes,
      onStart = _ref.onStart,
      onSuccess = _ref.onSuccess,
      onFailure = _ref.onFailure,
      onAbort = _ref.onAbort;
    _classCallCheck(this, Experience);
    _defineProperty(this, "_hasStopped", false);
    this.name = name;
    this.id = id;
    this.timeout = timeout;
    this.startTime = startTime;
    this.attributes = attributes;
    this.onSuccess = onSuccess;
    this.onFailure = onFailure;
    this.onAbort = onAbort;
    var startEvent = {
      action: 'taskStart',
      name: name,
      id: id,
      startTime: startTime,
      timeout: timeout,
      attributes: attributes
    };
    if (onStart) {
      this.onStop = onStart(startEvent);
    }
  }
  return _createClass(Experience, [{
    key: "hasStopped",
    get: function get() {
      return this._hasStopped;
    }
  }, {
    key: "succeed",
    value: function succeed(attributes) {
      if (this._hasStopped) {
        return;
      }
      this.onSuccess && this.onSuccess();
      this.stop({
        action: 'taskSuccess',
        name: this.name,
        id: this.id,
        startTime: this.startTime,
        duration: this.getDuration(),
        attributes: mergeAttributes(this.attributes, attributes)
      });
    }
  }, {
    key: "fail",
    value: function fail(_ref2) {
      var error = _ref2.error,
        attributes = _ref2.attributes;
      if (this._hasStopped) {
        return;
      }
      this.onFailure && this.onFailure();
      this.stop({
        action: 'taskFail',
        name: this.name,
        id: this.id,
        startTime: this.startTime,
        duration: this.getDuration(),
        error: error,
        attributes: mergeAttributes(this.attributes, attributes)
      });
    }
  }, {
    key: "abort",
    value: function abort(_ref3) {
      var reason = _ref3.reason,
        attributes = _ref3.attributes,
        _ref3$checkForTimeout = _ref3.checkForTimeout,
        checkForTimeout = _ref3$checkForTimeout === void 0 ? true : _ref3$checkForTimeout;
      if (this._hasStopped) {
        return;
      }

      // Check if the experience should have failed due to timeout
      if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
        this.fail({
          attributes: attributes,
          error: new ExperienceTimeoutError("".concat(this.name, " failed to complete in ").concat(this.timeout, "ms"))
        });
        return;
      }
      this.onAbort && this.onAbort();
      this.stop({
        action: 'taskAbort',
        name: this.name,
        id: this.id,
        startTime: this.startTime,
        duration: this.getDuration(),
        reason: reason,
        checkForTimeout: checkForTimeout,
        attributes: mergeAttributes(this.attributes, attributes)
      });
    }
  }, {
    key: "stopOn",
    value: function stopOn(event) {
      if (!event) {
        return;
      }
      if (event.action === 'taskSuccess') {
        this.succeed();
      } else if (event.action === 'taskAbort') {
        this.abort({
          reason: event.reason,
          checkForTimeout: event.checkForTimeout
        });
      } else if (event.action === 'taskFail') {
        this.fail({
          error: event.error
        });
      }
    }
  }, {
    key: "stop",
    value: function stop(event) {
      this._hasStopped = true;
      if (this.onStop) {
        this.onStop(event);
      }
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return Math.round(window.performance.now() - this.startTime);
    }
  }]);
}();